import React from 'react'
import BranchViewPage from '../sections/branch/view/brach-view'


function BranchPage() {
  return (
   <>
   <BranchViewPage/>
   </>
  )
}

export default BranchPage